<button
  type="button"
  [disabled]="readOnlyAccess || disableConvertAction"
  class="document-action convert-action"
  (click)="convertToInvoice()"
>
  {{ 'ACTION.CONVERT_TO_INVOICE' | translate }}

  <app-premium-icon *ngIf="!convertPermission" class="premium-icon">
  </app-premium-icon>
</button>
